import { render, staticRenderFns } from "./ModelPlace.vue?vue&type=template&id=2a093e6a&scoped=true&"
import script from "./ModelPlace.vue?vue&type=script&lang=js&"
export * from "./ModelPlace.vue?vue&type=script&lang=js&"
import style0 from "./ModelPlace.vue?vue&type=style&index=0&id=2a093e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a093e6a",
  null
  
)

export default component.exports